import { Modal } from "react-bootstrap";
import { Dependent } from "@basicare/common/src/Models/dependent.model";
import Button from "@basicare/common/src/Components/Themed/Button";
import DependentCard from "./DependentCard";

const RemoveDependentModal = ({
  show,
  dependent,
  onConfirm,
  handleClose,
}: {
  show: boolean;
  dependent: Dependent;
  onConfirm: () => void;
  handleClose: () => void;
}) => (
  <Modal show={show} onHide={handleClose} dialogClassName="mw--750">
    <Modal.Body className="d-flex align-items-center flex-column">
      <h2 className="text-center border-bottom py-4">
        Are you sure you want to remove this dependent?
      </h2>
      <DependentCard dependent={dependent} />
    </Modal.Body>
    <Modal.Footer className="border-0 pt-0 d-flex justify-content-center">
      <Button
        variant="primary"
        className="px-4 m-2"
        outline
        onClick={() => {
          onConfirm();
          handleClose();
        }}
      >
        Yes
      </Button>
      <Button className="px-4 m-2" variant="primary" onClick={handleClose}>
        No
      </Button>
    </Modal.Footer>
  </Modal>
);

export default RemoveDependentModal;
